import { descriptionText } from './descriptionText';

export function normalizeCatalog(catalog) {
  const data = catalog?.data || {};
  const categories = new Map();
  (data.categories || []).forEach((c) => {
    if (c.ref) categories.set(c.ref, c.name);
    if (c.id) categories.set(c.id, c.name);
  });
  return (data.products || []).map((p, index) => ({
    id: p.id || p.ref || String(index), name: p.name, source_name: p.name, description: p.description || '',
    category: categories.get(p.category_ref || p.category_id) || 'Other',
    price: p.skus?.[0]?.price || null, variants: p.skus || [],
    pos_ref: p.skus?.[0]?.ref || '',
    options: (p.skus || []).flatMap((sku) => sku.option_list_refs || sku.option_list_ids || []),
    hidden: false, sold_out: false,
    labels: (p.tags || []).join(', '), image: catalog.images?.[p.image_ids?.[0]] || '', popular: false, ask_guest_name: false,
    recommended_products: [],
    optionGroups: (data.option_lists || []).filter(group => (p.skus || []).some(sku => (sku.option_list_ids || []).includes(group.id) || (sku.option_list_refs || []).includes(group.ref))),
  })).map(product => {
    const edits = catalog.presentation?.[product.id];
    return edits ? {...product, name: edits.display_name || product.name, description: edits.description ?? product.description,
      labels: edits.labels, image: edits.image || (edits.image_overridden ? '' : product.image),
      hidden: !edits.is_visible, sold_out: !!edits.sold_out, popular: edits.popular, ask_guest_name: edits.ask_guest_name, recommended_products: edits.recommended_products} : product;
  }).map(product => ({...product, description: descriptionText(product.description)}));
}

export function money(value) {
  if (!value) return 'Price not set';
  const match = String(value).match(/^(\d+(?:\.\d+)?) ([A-Z]{3})$/);
  if (!match) return value;
  try { return new Intl.NumberFormat('en', { style: 'currency', currency: match[2] }).format(Number(match[1])); }
  catch { return value; }
}

export const previewMenu = [
  { id: 'burger', name: 'Classic cheeseburger', category: 'Mains', description: 'Grilled beef, cheddar, crisp lettuce and our house sauce.', price: '12.00 EUR', emoji: '🍔', color: '#faf0db', options: ['Size', 'Extras'], variants: [{name:'Regular',price:'12.00 EUR'},{name:'Large',price:'16.00 EUR'}] },
  { id: 'salmon', name: 'Grilled salmon', category: 'Mains', description: 'Lemon butter, seasonal greens and roasted potatoes.', price: '19.00 EUR', emoji: '🐟', color: '#e8f0eb', options: ['Sides'], variants: [] },
  { id: 'burrata', name: 'Burrata & tomatoes', category: 'Starters', description: 'Creamy burrata, heirloom tomatoes and basil oil.', price: '11.50 EUR', emoji: '🥗', color: '#f3e8e0', options: [], variants: [] },
  { id: 'fries', name: 'French fries', category: 'Sides', description: 'Golden fries with sea salt. Made for sharing.', price: '4.50 EUR', emoji: '🍟', color: '#f9ecd5', options: ['Sauce'], variants: [] },
  { id: 'beer', name: 'Draft beer', category: 'Drinks', description: 'A crisp, refreshing house lager.', price: '5.00 EUR', emoji: '🍺', color: '#f4ead9', options: [], variants: [] },
  { id: 'cake', name: 'Chocolate fondant', category: 'Desserts', description: 'Warm chocolate centre, vanilla ice cream.', price: '7.00 EUR', emoji: '🍫', color: '#ece4e0', options: [], variants: [] },
];
